export function parseComment(comment) {
  return {
    createdAt: comment.created_at,
    creator_guid: comment.creator_guid,
    guid: comment.guid,
    text: comment.message,
    user: {
      avatar: comment?.user?.avatar || comment.creator_avatar,
      creator_guid: comment?.user?.guid || comment.creator_guid,
      lastName: comment?.user?.lastname || comment.creator_lasname,
      name: comment?.user?.name || comment.creator_name,
    },
  };
}
